import classNames from 'classnames';
import { useMemo } from 'react';
import { Select, SelectValue } from 'tdesign-react';

import { EditorAddMultiCharacter, RemoveFore } from '@/components/icon';
import { ActionType, ChangeMediaOperationType, ChangeMediaType, EventType } from '@/const/mission';
import { IEvents } from '@/interface';
import { MultiCharacter, ThumbnailType } from '@/interface/media';
import CharacterPreviewAndEdit from '@/material/form-upload/character/previewAndEdit';

import styles from '../index.module.less';

interface IProps {
  value: IEvents;
  disabled: boolean;
  contentEventIdColWidth: number | undefined;
  thumbnail?: ThumbnailType;
  onChange: (value: any) => void;
}

const CharacterItem: React.FC<IProps> = (props) => {
  const { value, disabled, thumbnail, onChange } = props;

  const handleChange = (data: MultiCharacter[]) => {
    const postData: IEvents = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          ...value?.action?.changeMedia,
          type: value?.action?.changeMedia?.type || ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER,
          multiVerticalPainting: data,
          operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
        },
      },
    };
    onChange(postData);
  };

  const operation = value?.action?.changeMedia?.operation;
  const isRemove = operation === ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE;

  const handleChangeSelect = (data: SelectValue) => {
    let postData = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          ...value?.action?.changeMedia,
        },
      },
    };

    if (data === ChangeMediaType.REMOVE_FORE_IMAGE) {
      const type = ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER;
      postData = {
        type: EventType.EVENT_TYPE_ACTION,
        action: {
          type: ActionType.ACTION_TYPE_CHANGEMEDIA,
          changeMedia: {
            type,
            operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_REMOVE,
            multiVerticalPainting: [],

          },
        },
      };
    } else {
      postData = {
        type: EventType.EVENT_TYPE_ACTION,
        action: {
          type: ActionType.ACTION_TYPE_CHANGEMEDIA,
          changeMedia: {
            ...value?.action?.changeMedia,
            type: data as ChangeMediaType,
            operation: ChangeMediaOperationType.CHANGE_MEDIA_OPERATION_TYPE_MODIFY,
          },
        },
      };
    }
    onChange(postData);
  };

  const options = [
    { label: '多人立绘', value: ChangeMediaType.CHANGE_MEDIA_TYPE_MULTI_CHARACTER },
    { label: '移除立绘', value: ChangeMediaType.REMOVE_FORE_IMAGE },
  ];

  const selectValue = useMemo(() => (isRemove
    ? ChangeMediaType.REMOVE_FORE_IMAGE
    : value?.action?.changeMedia?.type
  ), [isRemove, value]);

  return (
    <div className={styles.itemBox}>
      <div className={classNames(styles.system, styles.leftType, styles.noPadding, 'draggable')}>
        <Select
          prefixIcon={<div className={styles.selectPreIcon}>
            {selectValue === ChangeMediaType.REMOVE_FORE_IMAGE
              ? <RemoveFore />
              : <EditorAddMultiCharacter />}
          </div>}
          className={styles.botSelect}
          value={selectValue}
          onChange={handleChangeSelect}
          options={options}
          disabled={disabled}
          defaultValue={options?.[0]?.value}
        />
      </div>
      <div className={styles.contentBox}>
        {isRemove
          ? <div className={classNames(styles.pauseAudio, 'draggable', {
            ['nova-disabled-opacity']: disabled,
            ['nova-disabled']: disabled,
          })}>
            <span>移除立绘</span>
            </div>
          : <CharacterPreviewAndEdit
              value={value?.action?.changeMedia?.multiVerticalPainting || []}
              disabled={disabled}
            thumbnail={thumbnail}
              onChange={handleChange}
            />
        }
      </div>
    </div>
  );
};

export default CharacterItem;
